import React, { forwardRef } from "react";
import PropTypes from "prop-types";

const Textarea = forwardRef(({ className = "", rows = 4, ...props }, ref) => (
  <textarea {...props} className={["wsm-textarea", className].filter(Boolean).join(" ")} ref={ref} rows={rows} />
));

Textarea.displayName = "Textarea";
Textarea.propTypes = { className: PropTypes.string, rows: PropTypes.number };
export default Textarea;
